import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SurveyMapPage } from './device/survey-map.page';
import { SurveyMapBrowserPage } from './browser/survey-map-browser.page';
import { Capacitor } from '@capacitor/core';

const routes: Routes = [
  {
    path: '',
    component: Capacitor.isNativePlatform() ? SurveyMapPage : SurveyMapBrowserPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SurveyMapPageRoutingModule {}
